var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogleIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "google-icon-logo-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.6,
    height: 20,
    viewBox: "0 0 19.6 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2086",
    "data-name": "Path 2086",
    d: "M140.15,108.805a8.569,8.569,0,0,0-.211-2.044H130.55v3.711h5.511a4.887,4.887,0,0,1-2.044,3.244l-.019.124,2.969,2.3.206.021a9.777,9.777,0,0,0,2.978-7.356",
    transform: "translate(-120.55 -98.583)",
    fill: "#4285f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M22.858,164.392a9.531,9.531,0,0,0,6.622-2.422l-3.156-2.445a5.919,5.919,0,0,1-3.467,1,6.02,6.02,0,0,1-5.689-4.156l-.117.01-3.087,2.389-.04.112a9.993,9.993,0,0,0,8.933,5.511",
    transform: "translate(-12.858 -144.392)",
    fill: "#34a853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    d: "M4.311,77.827a6.156,6.156,0,0,1-.333-1.978A6.469,6.469,0,0,1,4.3,73.872l-.006-.133L1.169,71.312l-.1.049a9.979,9.979,0,0,0,0,8.978l3.244-2.511",
    transform: "translate(0 -65.85)",
    fill: "#fbbc05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    d: "M22.858,3.867a5.542,5.542,0,0,1,3.867,1.489L29.547,2.6A9.608,9.608,0,0,0,22.858,0a9.993,9.993,0,0,0-8.933,5.511l3.233,2.511a6.045,6.045,0,0,1,5.7-4.156",
    transform: "translate(-12.858)",
    fill: "#eb4335"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google_icon.96cbebf642a3667fdf015bfe876a4bae.svg";